export default __webpack_public_path__ + "static/media/p3_token.2ed8c483.png";